
const gravity = 0.3
const radius = 5

const colors = [
    'rgba(99, 212, 252, 0.9)',
    'rgba(252, 215, 49, 0.9)',
    'rgba(172, 151, 215, 0.9)',
    'rgba(183, 223, 214, 0.9)',
    'rgba(244, 167, 210, 0.9)'
]

interface Mote {
    x: number
    y: number
    vx: number
    vy: number
    radius: number
    color: string
}

function createMote(x: number, y: number): Mote {
    const vx = (Math.random() * -10) + 5
    const vy = (Math.random() * -10) - 5
    return { x, y, vx, vy, radius, color: colors[Math.floor(Math.random() * colors.length)] }
}

function draw(mote: Mote, ctx: CanvasRenderingContext2D) {
    const { x, y, radius, color } = mote
    ctx.fillStyle = color
    ctx.beginPath()
    ctx.arc(x, y, radius, 0, Math.PI * 2, false)
    ctx.closePath()
    ctx.fill()
}

function update(mote: Mote) {
    mote.x += mote.vx
    mote.y += mote.vy
    mote.vy += gravity
}

export async function init(moteCount: number, canvas: HTMLCanvasElement) {

    const ctx = canvas.getContext('2d')
    const W = canvas.width = window.innerWidth
    const H = canvas.height = window.innerHeight
    const motes: Mote[] = []
    const start = Date.now()
    const duration = 1000 * 3

    if (!ctx) { return Promise.reject() }

    for (let i = 0; i < moteCount; i++) {
        motes.push(createMote(W / 2, H / 2))
    }

    return new Promise((resolve) => {

        (function renderFrame() {
            ctx.clearRect(0, 0, W, H)

            for (const mote of motes) {
                update(mote)
                draw(mote, ctx)
            }

            const now = Date.now()
            if (start + duration > now) {
                requestAnimationFrame(renderFrame)
            } else {
                resolve()
            }
        }())
    })
}
